import { INotificationEntries } from "../types";
import {
  DeleteAllApplicationUserNotificationsByUserId,
  DeleteApplicationUserNotification,
} from "../../../api/applicationNotificationApiCalls";
import { useState } from "react";
import { GetCurrentUser, GetUserToken } from "../../../utilities/functions";
import { IApplicationUserNotification } from "../../../utilities/interfaces";

interface L33tProps {}

const NotificationBarComponent: React.FC<L33tProps> = (props) => {
  const [
    formattedApplicationNotificationStatusArray,
    setFormattedApplicationNotificationStatusArray,
  ] = useState<INotificationEntries[]>([]);

  const userLoggedIn = GetCurrentUser();
  const token = GetUserToken();

  async function ClearAllNotifications() {
    await DeleteAllApplicationUserNotificationsByUserId(
      userLoggedIn?.id!,
      token
    );
    setFormattedApplicationNotificationStatusArray([]);
  }
  async function HandleNotificationListItemClick(
    Notification: INotificationEntries
  ) {
    await DeleteApplicationUserNotification(
      Notification.associateedNotificationEntries.map(
        (notification: IApplicationUserNotification) => notification.id!
      ),
      token
    ).then((resp: any) => {
      window.location.href = `${process.env.REACT_APP_FRONTEND_BASE_URL}/home/craneApplicationStatus/${Notification.appId}`;
    });
  }
  //   add this compent to teack prev notification
  //   useEffect(() => {
  //                 GetApplicationUserNotificationStatus(parseFloat(userDetails.id), token).then((applicationNotificationResponse) => {
  //                     let errors = applicationNotificationResponse[1];
  //                     let applicationNotificiationStatusArray = applicationNotificationResponse[0];

  //                     if (errors) {
  //                         setNetworkError(true);
  //                     } else {
  //                         setApplicationNotificationStatus(applicationNotificiationStatusArray.data);

  //                         FormatApplicationNotificationsList(applicationNotificiationStatusArray.data);
  //                     }
  //                 });

  //     }
  //   }, []);

  if (formattedApplicationNotificationStatusArray?.length !== 0)
    return (
      <li className='nav-item mx-2 '>
        <a
          className='notificationButton mt-2 '
          href='#'
          id='navbarDropdownMenuLink'
          role='button'
          data-bs-toggle='dropdown'
          aria-expanded='false'
        >
          <i className='far fa-bell fa-lg mt-2'></i>
          {formattedApplicationNotificationStatusArray?.length !== 0 && (
            <span className='button_badge'>
              {formattedApplicationNotificationStatusArray?.length}
            </span>
          )}
        </a>
        <ul
          className='dropdown-menu dropdown-menu-end notificationList'
          aria-labelledby='navbarDropdownMenuLink'
        >
          {formattedApplicationNotificationStatusArray?.map(
            (notification: INotificationEntries, index) => (
              <li
                key={index}
                className=' dropdown-menu-lg-right dropdown-secondary'
                aria-labelledby='navbarDropdownMenuLink-5'
              >
                <a
                  className=' text-label mx-1 dropdown-item waves-effect waves-light'
                  onClick={() => HandleNotificationListItemClick(notification)}
                >
                  {" "}
                  {notification.associateedNotificationEntries.length > 1
                    ? `${notification.associateedNotificationEntries.length} new comments have been made to application ${notification.appId}`
                    : `A new comment has been posted to application ${notification.appId}`}
                </a>
              </li>
            )
          )}
          <button
            className='btn btn-secondary btn-xs float-end clearButton mx-1 mt-3'
            onClick={() => ClearAllNotifications()}
          >
            Clear all
          </button>
        </ul>
      </li>
    );
  else return <></>;
};

export default NotificationBarComponent;
